<template>
  <div class="list-page">
    <div v-if="project && project.projectId != 'undefined'">
      <div class="layout__content__header list-page__header layout__content__header--white">
        <CopyNotification
          :opened="copyConfirmVisible"
          :text="'zkopirovanoDoSchranky'"
          @close="copyConfirmVisible = false"
        />
        <div v-if="project" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("HEADER_SIMCARDS") }}
          </h1>
          <div class="list-page__buttons align-items-center d-flex d-sm-none">
            <!--            <button-->
            <!--              v-if="project.projectId && apiUser && apiUser.isCustomerAdmin"-->
            <!--              @click="createNewSimcard()"-->
            <!--              class="btn btn-primary d-flex align-items-center justify-content-center"-->
            <!--            >-->
            <!--              <div class="atom-icon">-->
            <!--                <img src="@/assets/icons/actions/ico-btn-nova.svg" />-->
            <!--              </div>-->
            <!--              {{ $t("BTN_NEW_SIMCARD") }}-->
            <!--            </button>-->

            <RouterLink
              v-if="project.projectId && apiUser && apiUser.isCustomerAdmin"
              :to="{
                name: 'newSimcard',
                params: { customerId: customerId, projectId: projectId }
              }"
              class="btn btn-primary d-flex align-items-center justify-content-center"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("BTN_NEW_SIMCARD") }}
            </RouterLink>
          </div>
        </div>
        <div v-if="project" class="d-flex justify-content-between">
          <div class="d-flex list-page__left align-items-center">
            <!--
            <div
              v-if="project.projectId"
              class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
            >
              <input
                type="text"
                id="guisearch"
                class="w-100"
                v-model="search"
                v-bind:placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
                v-on:keyup.enter="searchSimcards()"
                ref="searchInput"
                autofocus
              />
              <div v-if="search" class="atom-icon" @click="clearSearch()">
                <img src="@/assets/icons/actions/ico-close.svg" />
              </div>
              <div class="atom-icon" @click="searchSimcards()">
                <img src="@/assets/icons/actions/ico-search-black.svg" />
              </div>
              <div class="custom-control--search__suggestions">
                <div
                  v-for="(suggestion, index) in suggestionsArray"
                  :key="index"
                  class="custom-control--search__suggestions__item"
                  @click="setSuggestion(suggestion)"
                >
                  <span>{{ suggestion }}</span>
                </div>
              </div>
            </div>
            -->

            <!--div class="list-page__link">         		<a class="d-flex align-items-center">         			{{ $t("pokrocilaFiltrace") }}         			<img src="@/assets/icons/arrows/arr-orange-down.svg" class="">         		</a>         	</div-->
          </div>
          <div class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between">
            <RouterLink
              v-if="project.projectId && apiUser && apiUser.isCustomerAdmin"
              :to="{
                name: 'newSimcard',
                params: { customerId: customerId, projectId: projectId }
              }"
              class="btn btn-primary d-flex align-items-center justify-content-center"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("BTN_NEW_SIMCARD") }}
            </RouterLink>
          </div>
        </div>
      </div>
      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <RadioHelp
          :article-link="'/simcards'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <RadioOpenClose
            :radio-slides="radioSlides"
            :show="showHelp"
            @update-show-radio-help="showRadioHelp($event)"
          />
        </div>
      </div>
      <div v-if="sortedSimcards.length > 0" class="layout__content__content pt-4 pt-md-5">
        <div v-click-outside="closeDropdownActions" class="dropdown-actions">
          <button v-if="selectedRows.length > 0" class="btn btn-primary" @click="showDropdownActions()">
            <div class="d-flex align-items-center">
              {{ $t("hromadneAkce") }}
              <img src="@/assets/icons/arrows/arr-down-white.svg" class="ml-2" />
            </div>
          </button>
          <button v-else class="btn btn-primary" disabled>
            <div class="d-flex align-items-center">
              {{ $t("hromadneAkce") }}
              <img src="@/assets/icons/arrows/arr-down-white.svg" class="ml-2" />
            </div>
          </button>
          <div v-if="isActionsDropdownVisible && selectedRows.length > 0" class="dropdown-actions__wrapper">
            <div class="dropdown-actions__inner">
              <div class="row">
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleChangeStatusModal('changeStatus')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                  </div>
                  {{ $t("zmenarezimu") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <TableV2
          :columns="columns"
          table-id="simcards"
          item-id="iccid"
          :items="sortedSimcards"
          :items-total-count="sortedSimcards.length"
          kebab
          selectable
          @rows-selected="selectedRows = $event"
        >
          <template #iccid="{ item }">
            <RouterLink
              :to="{
                name: 'simcard',
                params: {
                  id: item.iccid,
                  simcard: item,
                  serviceId: item.custServiceId,
                  customerId: customerId,
                  projectId: projectId
                }
              }"
              class="font-weight-bolder link-gray"
            >
              {{ item.iccid }}
            </RouterLink>
          </template>

          <template #status="{ item }">
            <div v-if="item.status == 'ACTIVE'" class="atom-circle atom-circle--success">
              <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_ACTIVE')">A</div>
            </div>
            <div v-else-if="item.status == 'OTHER'" class="atom-circle atom-circle--warning">
              <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_OTHER')">0</div>
            </div>
            <div v-else-if="item.status == 'PENDING_ACTIVATION'" class="atom-circle atom-circle--warning">
              <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_PENDING_ACTIVATION')">P</div>
            </div>
            <div v-else-if="item.status == 'SUSPENDED'" class="atom-circle atom-circle--gray">
              <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_SUSPENDED')">S</div>
            </div>
          </template>

          <template #msisdn="{ item }">+{{ item.msisdn }}</template>

          <template #kebab-actions="{ item }">
            <div
              class="dropdown-actions__item d-flex align-items-center"
              @click="
                () => {
                  actionItems = [item]
                  toggleEditSimcardModal('editItem')
                }
              "
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
              </div>
              {{ $t("upravitSimcard") }}
            </div>
          </template>
        </TableV2>
      </div>
      <div
        v-else-if="simcardsLoaded && !loadingData && customerSimcardService === true && projectSimcardService === false"
        class="layout__content__content pt-4 pt-md-5"
        v-html="$t('SIMCARDS_NOSERVICE_FOR_PROJECT')"
      />
      <div
        v-else-if="simcardsLoaded && !loadingData && customerSimcardService === false"
        class="layout__content__content pt-4 pt-md-5"
        v-html="$t('SIMCARDS_NOSERVICE_FOR_CUSTOMER')"
      />
      <div
        v-else-if="simcardsLoaded && !loadingData && projectSimcardService === true"
        class="layout__content__content pt-4 pt-md-5"
      >
        {{ $t("nicKZobrazeni") }}.
      </div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <AppLoader />
      </div>
    </div>
    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("HEADER_SIMCARDS") }}
          </h1>
        </div>
      </div>
    </div>
    <ChangeStatusModal
      :items="actionItems"
      :opened="openedChangeStatusModal"
      @open-box="toggleChangeStatusModal"
      @close-box="toggleChangeStatusModal"
      @info="toggleConfirmation"
    />

    <DeleteDeviceModal
      :opened="openedDeleteSimcard"
      :items="actionItems"
      :text="deleteText"
      :centered="true"
      @yes="
        () => {
          deleteDevice()
          toggleDeleteDevice()
        }
      "
      @close="toggleDeleteDevice()"
    />
    <EditDeviceModal
      v-if="openedEditSimcard.length > 0"
      :item="actionItems[0]"
      :opened="openedEditSimcard"
      @open-box="toggleEditSimcardModal"
      @close-box="toggleEditSimcardModal"
      @reload-items="reloadItems()"
      @info="toggleConfirmation"
    />

    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :opened="openedError" :centered="true" :errors="errorsToTranslate" @close="openedError = false" />
    </div>
    <InfoModal
      :opened="openedInfoConfirmation"
      :text="'SIMCARD_CHANGE_STATUS_INFO'"
      :centered="true"
      @close="toggleConfirmation"
    />
  </div>
</template>
<script>
import axios from "axios"
import _ from "lodash"
import TableV2 from "@/components/custom-table/TableV2.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import ChangeStatusModal from "@/components/modals/simcards/changeStatus.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import EditDeviceModal from "@/components/modals/simcards/edit.vue"
import DeleteDeviceModal from "@/components/confirmations/delete.vue"
import Notify from "@/components/notify/notify.vue"
import Loader from "@/components/loader.vue"
import InfoModal from "@/components/confirmations/info.vue"
import { mapGetters } from "vuex"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    TableV2,
    RadioHelp,
    RadioOpenClose,
    ChangeStatusModal,
    ErrorModal,
    CopyNotification: Notify,
    DeleteDeviceModal,
    EditDeviceModal,
    AppLoader: Loader,
    InfoModal
  },
  setup() {
    const authStore = useAuthStore()
    const configStore = useConfigStore()
    const projectStore = useProjectStore()

    return { authStore, configStore, projectStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      columns: [
        {
          title: "iccid",
          name: "iccid",
          sortable: true,
          sortBy: "iccid",
          minWidth: "220px"
        },
        {
          title: "status",
          name: "status",
          sortable: true,
          sortBy: "status",
          minWidth: "50px"
        },
        {
          // flexible column: width:auto absorbs the table's spare horizontal
          // space (table-layout:fixed + width:100%) so the icon/number columns
          // render at their true widths instead of stretching proportionally
          title: "friendlyName",
          name: "friendlyName",
          sortable: true,
          sortBy: "friendlyName",
          minWidth: "auto"
        },
        {
          title: "msisdn",
          name: "msisdn",
          sortable: true,
          sortBy: "msisdn",
          minWidth: "auto"
        },
        {
          title: "imsi",
          name: "imsi",
          sortable: true,
          sortBy: "imsi",
          minWidth: "auto"
        }
      ],
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      columnsTypeName: "columnsSimcards",
      search: "",
      suggested: "",
      suggestionsArray: [],
      isActionsDropdownVisible: false,
      sort: "custDestName",
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      openedSideBox: false,
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      openedNewSimcard: [],
      tags: [],
      toDelete: [],
      openedDeleteSimcard: false,
      openedChangeStatusModal: [],
      deleteText: "",
      pingResponses: [],
      openedPingSimcard: false,
      openedEditSimcard: [],
      copyConfirmVisible: false,
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      sortedSimcards: [],
      loaded: true,
      loadingData: true,
      // true only after the sim-card list query has actually returned; gates the
      // empty / no-service branches so they can't flash while the list loads (PIX-549)
      simcardsLoaded: false,
      tableColumnsDefault: {
        iccid: {
          show: true,
          order: 1,
          title: "iccid"
        },
        status: {
          show: true,
          order: 2,
          title: "status"
        },
        friendlyName: {
          show: true,
          order: 3,
          title: "friendlyName"
        },
        msisdn: {
          show: true,
          order: 4,
          title: "msisdn"
        },
        imsi: {
          show: true,
          order: 5,
          title: "imsi"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      openedInfoConfirmation: false
    }
  },
  computed: {
    apiUser() {
      return this.authStore.apiUser
    },
    allSimcards() {
      return this.$store.getters["simcards/allSimcards"]
    },
    // Read reactively from the store (committed by the service-check queries in
    // getAllSimcards) instead of a one-shot localStorage read, so the branch
    // logic uses fresh booleans and self-corrects when the checks land (PIX-549).
    customerSimcardService() {
      return this.$store.getters["simcards/customerSimcardService"]
    },
    projectSimcardService() {
      return this.$store.getters["simcards/projectSimcardService"]
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    search() {
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    project() {
      this.loadSimcards()
      this.selectedRows = []
    },
    sort() {},
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    }
  },
  mounted() {
    this.tableColumns = this.getTableColumns()
    this.showHelp = !this.radioDisabled

    if (this.project) this.loadSimcards()
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    reloadItems() {
      this.loadSimcards()
    },
    async loadSimcards() {
      this.simcardsLoaded = false
      this.loadingData = true

      let simcards = await this.$store.dispatch("simcards/getAllSimcards", {
        search: false,
        sort: this.sort
      })
      if (simcards) {
        // project-scoped list; stamp projectId so TableV2's row checkbox gate
        // (item.projectId === selectedProjectId) renders the selection controls
        this.sortedSimcards = this.allSimcards.map((simcard) => ({ ...simcard, projectId: this.projectId }))

        //this.getAllTags();
        this.simcardsLoaded = true
        this.loadingData = false
        this.$store.commit("modals/setWaitingLoader", "")
      } else {
        this.loadingData = false
      }
    },
    searchSimcards() {
      this.suggestionsArray = []
      this.sortedSimcards = this.allSimcards.filter(
        (endpoint) => endpoint.custDestName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      )
    },
    reloadSimcards() {
      this.openedNewSimcard = []
      this.openedAddToGroups = []
      this.openedRemoveFromGroups = []
      this.loadSimcards()
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.searchSimcards()
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = this.isActionsDropdownVisible ? false : true
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = this.openedRowsSelect ? false : true
    },
    toggleGroup(device) {
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.allSimcards)
        this.openedGroups = [].concat.apply([], this.allSimcards)
        this.toggledAllRows = true
      }
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleNewSimcard() {
      this.openedNewSimcard = this.openedNewSimcard ? false : true
    },
    createNewSimcard() {
      this.openedNewSimcard.push("newSimcard")
    },
    closeNewSimcardModal(box) {
      box == undefined
        ? (this.openedNewSimcard = [])
        : this.openedNewSimcard.splice(this.openedNewSimcard.indexOf(box), 1)
    },
    openNextNewSimcardModal(box) {
      this.openedNewSimcard.push(box)
    },
    getAllTags() {
      this.tags = _(this.allSimcards)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleDeleteSimcard(items) {
      if (this.openedDeleteSimcard == true) {
        this.openedDeleteSimcard = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "endpointyLabel" : items[0].custDestName
        }
        this.openedDeleteSimcard = true
      }
    },
    deleteSimcard() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      // let totalLength = this.actionItems.length;
      // var totalDone = 0;
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      this.actionItems.forEach((item) => {
        let id = item.iccid

        console.log("id to delete " + id)
        promises.push(
          axios
            .delete(process.env.VUE_APP_API + "/http/simcards/" + id, {})
            .then(() => {
              this.selectedRows = this.selectedRows.filter(function (obj) {
                return obj.iccid !== id
              })

              this.reloadSimcards()
              notifications.push({
                text: "notificationSimcardDelete",
                error: false,
                params: {
                  iccid: item.iccid,
                  custDestName: item.custDestName
                }
              })
            })
            .catch((error) => {
              console.log("push erorr to translate")
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  iccid: item.iccid,
                  custDestName: item.custDestName
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })

      Promise.allSettled(promises).then(() => {
        console.log("all logs are done")

        this.$store.commit("modals/setWaitingLoader", "")
        this.$store.commit("modals/setGlobalNotification", notifications)
        // this.selectedRows = [];
        this.openedError = true

        this.loadSimcards()
      })
    },
    toggleEditSimcardModal(box) {
      if (this.openedEditSimcard.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditSimcard = [])
          : this.openedEditSimcard.splice(this.openedEditSimcard.indexOf(box), 1)

        this.selectedRows = []
        this.selectedAll = false
        if (box == undefined || box == "editItem") {
          this.openedDevice = {}
        }
      } else {
        this.openedEditSimcard.push(box)
        if (box == "editItem") {
          this.reloadEditedDevice = true
          setTimeout(() => {
            this.reloadEditedDevice = false
          }, 1500)
        }
      }
    },
    switchSimcards(value) {
      let array = this.actionItems
      this.errorsToTranslate = []
      let promises = []
      array.forEach((item) => {
        let id = item.iccid
        item.custDestDescription = ""
        if (value == undefined) {
          item.custDestEnabled = item.custDestEnabled ? false : true
        } else {
          item.custDestEnabled = value
        }
        promises.push(
          axios
            .put(process.env.VUE_APP_API + "/http/simcards/" + id, item, {})
            .then(() => {})
            .catch(() => {})
        )
      })
      Promise.all(promises).then(() => {
        this.openedError = true
      })
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      console.log("this.tableColumns")
      console.log(this.tableColumns)
      this.showSidebarTableColumnOrder = false
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    },
    toggleChangeStatusModal(box) {
      if (box == undefined || this.openedChangeStatusModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedChangeStatusModal = [])
          : this.openedChangeStatusModal.splice(this.openedChangeStatusModal.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedChangeStatusModal.push(box)
      }
    },
    toggleConfirmation() {
      this.openedInfoConfirmation = this.openedInfoConfirmation ? false : true
    }
  }
}
</script>
<style lang="scss" scoped></style>
